var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-md-4 col-xl-2"},[_c('div',[_c('json-viewer',{attrs:{"value":_vm.data}})],1),_c('l-button',{staticClass:"btn-filter shadow-sm",staticStyle:{"margin-top":"30px"},attrs:{"wide":"","type":"primary"},on:{"click":_vm.send}},[_vm._v("\n    "+_vm._s(_vm.$t('common_words.send'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }